import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";

const InfoAlert = ({ message, btn }) => {
  return (
    <div
      className="flex items-center bg-blue/10 border border-blue/40 text-blue px-4 py-3 rounded-lg mb-6"
      role="alert"
    >
      <AiOutlineInfoCircle className="text-blue-500 mr-3" size={24} />
      <span className="flex-grow">{message}</span>
      {btn}
    </div>
  );
};


const YellowAlert = ({ message, btn }) => {
  return (
    <div 
      className="flex items-center bg-amber-50 dark:bg-amber-400/10 border 
                 border-amber-200 dark:border-amber-400/20 
                 text-amber-800 dark:text-amber-300
                 px-4 py-3 rounded-lg mb-6 gap-1" 
      role="alert"
    >
      <span className="flex-grow">{message}</span>
      {btn}
    </div>
  );
};

export { InfoAlert, YellowAlert };
